const ITEMS = [
    "LET'S BUILD SOMETHING",
    "YOUR VISION. ONLINE.",
    "START TODAY",
    "NO TEMPLATES",
    "BUILT TO CONVERT",
];

export const TickerStrip = () => (
    <div className="relative z-10 my-6 -ml-[4%] w-[108%] -rotate-[1.3deg] overflow-hidden border-y-2 border-[#05070B] bg-[#0066FF] py-3.5 shadow-[0_10px_40px_rgba(0,102,255,0.35)]" data-testid="ticker-strip" aria-hidden="true">
        <div className="marquee-track flex w-max" style={{ animationDuration: "26s" }}>
            {[0, 1].map((dup) => (
                <div key={dup} className="flex shrink-0 items-center">
                    {ITEMS.map((t, i) => (
                        <span
                            key={`${dup}-${i}`}
                            className="flex items-center gap-7 pr-7 font-display text-sm uppercase tracking-[0.14em] text-[#05070B] sm:text-base"
                        >
                            {t}
                            <span className="text-xs">★</span>
                        </span>
                    ))}
                </div>
            ))}
        </div>
    </div>
);
